<template>
    <div id="content">


    <sweet-modal width="70%" ref="modal_stat" title="Statistique Google DataStudio">
      <div>
          <iframe v-if="stat_url" :src="`${stat_url}`" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>
    </sweet-modal>

        <sweet-modal  v-if="usersinfos.role ==='ADMIN'" ref="modal" title="Nouvelle opération">
            <form>
                <div class="formduo">
                    <!-- form 1-->
                    <div class="form">
                        <label for="date_debut">date de début <span>*</span></label>
                        <template>
                            <vue-datepicker-local
                                name="date_debut"
                                :local='local'
                                format="DD MMMM YYYY HH:mm:ss"
                                v-model="form.date_debut" />
                                </template>
                        <div class="error">{{ errors.first('date_debut') }}</div>
                    </div>
                    <div class="form">
                        <label for="date_fin">date de fin <span>*</span></label>
                            <template>
                                <vue-datepicker-local
                                    name="date_fin"
                                    :local='local'
                                     format="DD MMMM YYYY HH:mm:ss"
                                     v-model="form.date_fin"  />
                                    </template>
                        <div class="error">{{ errors.first('date_fin') }}</div>
                    </div>
                </div>
                <label for="title">titre <span>*</span></label>
                <input  type="text"
                        id="title"
                        name="title"
                        v-validate="'required'"
                        v-model="form.title"
                        placeholder="Titre de l'opération">
                <div class="error">{{ errors.first('title') }}</div>
                <br />


              <label>type d'opération <span>*</span></label>
              <multiselect
                v-model="form.type"
                :options="typeList"
                name="type"
                id="type"
                v-validate="'required'"
                :searchable="false"
                :show-labels="false"

                placeholder="Type de jeu"
              >
              </multiselect>
              <div class="error">{{ errors.first("type") }}</div>


     <br />
        <label>Format <span>*</span></label>
              <multiselect
                v-model="form.format"
                :options="typeList2"
                name="format"
                id="format"
                :searchable="false"
                :show-labels="false"
                placeholder="Format"
              >
              </multiselect>
              <div class="error">{{ errors.first("format") }}</div>
              <br />

                                    <div class="elem"  style="width: 100%;">
        <label>Schema Saisie (json):</label>
        <textarea v-model="form.saisieFormSchema" style="width: 95%;"></textarea>

      </div>

                <span class="obl" >*champs obligatoires</span>
                <div class="form-end">
                    <button class="btn-red"
                            v-on:click="closeModal()"> Annuler</button>&nbsp;
                    <button class="btn-blue"
                            v-on:click="submited()"><i class="fa fa-save"></i> Créer</button>
                </div>
            </form>
        </sweet-modal>
        <div class="contenair homeop">
            <h1 v-if="!logo_url || logo_url === 'undefined'"><i class="fa fa-file-text-o" aria-hidden="true"></i> Opérations</h1>
            <h1 v-else><img :src="`${logo_url}`"></h1>
            <div  class="add-op">
                <button v-if="usersinfos.role==='ADMIN'" class="btn-blue" v-on:click="openModal()"><i class="fa fa-plus"></i> Nouvelle opération</button>
                <button v-if="usersinfos.role==='ADMIN'" class="btn-blue" style="background-color:black;" v-on:click="majStat()"> Maj Stats</button>
            </div>
            <br />



 <VueFuse placeholder="Recherchez une opération" style="display:none" event-name="results" :list="filtered" :keys="['title', '_id', 'env']" />




                 <MyDataset

      v-slot="{ ds }"
      :ds-data="results">
      <div :data-page-count="ds.dsPagecount">



            <div v-if="usersinfos.role ==='ADMIN'" class="research">
                   <dataset-search
            class="bg-transparent text-lightblue font-bold placeholder-lightblue"
            onfocus="this.placeholder=''" ds-search-placeholder="Rechercher une opération"
          />

               <span>Type&nbsp;:&nbsp;</span><select @change="addType()" v-if="usersinfos.role ==='ADMIN'" v-model="state_op">
                   <option value="ALL" selected>TOUT</option>
                   <option value="PROD">PRODUCTION</option>
                   <option value="TEST">TEST</option>
                   <option value="GABARIT ODR">GABARIT ODR</option>
                    <option value="PERSONNALISER">HORS GABARIT</option>

                </select>


               Client&nbsp;:&nbsp;<select @change="addClient()" v-if="usersinfos.role ==='ADMIN'" v-model="client_op">
                   <option value="ALL" selected></option>
                <option v-for="(item, index) in clientList" :key="index" :value="item">{{ item}}</option>


                </select>

            </div>



                  <br />
            <h3>{{ totalop }} Opération(s)</h3>

            <vue-tabs v-if="usersinfos.role ==='ADMIN'" @tab-change="handleTabChange">
                <v-tab title="Toutes"> </v-tab>
                <v-tab title="En attente"> </v-tab>
                <v-tab title="En cours"> </v-tab>
                <v-tab title="Terminé"></v-tab>
                <v-tab title="Saisies"></v-tab>
                <v-tab title="Remboursements"></v-tab>
                <v-tab title="Synthèse client"></v-tab>
                <v-tab title="Archives"></v-tab>
            </vue-tabs>
            <br />



            <div class="bloc-ope" v-if="!loaded">
                <div style="height:300px; width:100%; text-align:center;">
	                        <img v-if="!majstat" src="/animated_loading.gif" height="200px">
                            <div v-if="majstat"><br><br>La mise à jour peut prendre un moment.<br>Vous pouvez continuer à utiliser l'interface.
                                <br><br><a  style="color:red;font-weight:bold" @click="loaded=true;majstat=false;">Continuer</a></div>

                </div>
            </div>



      <transition v-if="tabIndex != 6" name="fade">


            <div class="bloc-ope"  v-if="loaded">


 <dataset-pager />
      <dataset-show class="nbresult" :ds-show-entries="selected" @changed="selected = $event" />
      <dataset-item class="w-[1270px] mt-10 flex flex-wrap">
        <template #default="{ row }">

                    <div   class="new_style_op">
                        <div class="op-status" v-bind:class="{ gabarit : row.format==='GABARIT ODR'}" v-if="row.type==='ODR'"> ODR</div>
                        <div class="op-status" v-bind:class="{ gabarit : row.format==='GABARIT ODR'}" v-if="row.type==='JEU WEB'">JEU</div>
                        <div class="op-status" v-bind:class="{ gabarit : row.format==='GABARIT ODR'}" v-if="row.type==='FORMULAIRE'">FORM</div>

                        <div class="op-infos1">

                            <h2  v-if="usersinfos.role==='ADMIN'">
                                <router-link v-if="row.builderV2" :to="'/operationV2/' + row._id" >{{ row.title }}</router-link>
                                <router-link v-else :to="'/operation/' + row._id">{{ row.title }}</router-link>
                            </h2>
                            <h2  v-else>
                                <a @click="goToProd(row.domaine)" target="_blank" style="color:#254FB2;cursor:pointer">{{ row.title }}</a>
                            </h2>

                             <div class="period"> <i class="fa fa-calendar" aria-hidden="true"></i> Du
                                <span class="bold">{{ row.date_debut | moment("dddd Do MMMM YYYY")  }}</span> au
                                <span class="bold">{{ row.date_fin | moment("dddd Do MMMM YYYY") }}</span>
                            </div>

                            <div class="fin-recla" v-if="row.date_fin_reclamation && usersinfos.role === 'ADMIN'">Fin des réclamations : {{ row.date_fin_reclamation | moment("dddd Do MMMM YYYY")  }}</div>


                                <div class="status-key">
                                <div v-if="usersinfos.role === 'ADMIN'" >
                                     <b v-if="row.status === 'not_yet'"  class="badge">Débute dans {{ getTimeRemaining(row.date_debut).days }} Jours</b>
                                     <b v-if="row.status === 'between'" class="badge-green">Se termine dans {{ getTimeRemaining(row.date_fin).days }} Jours</b>
                                     <b v-if="row.status === 'finished'" class="badge-red">Terminé</b>
                                     <a v-if="row.domaine" @click="goToProd(row.domaine)" v-tooltip="'Lien Prod'" class="badge-gray" style="cursor:pointer" >PROD</a>
                                     <a v-if="row.domaine_dev" @click="goToProd(row.domaine_dev)" v-tooltip="'Lien Dev'" class="badge-gray" style="cursor:pointer">DEV</a>
                                </div>
                                 <div v-else>
                                    <b v-if="row.status === 'not_yet'" class="badge">Débute dans {{ getTimeRemaining(row.date_debut).days }} Jours</b>
                                    <b v-if="row.status === 'between'" class="badge-green">Se termine dans {{ getTimeRemaining(row.date_fin).days }} Jours</b>
                                    <b v-if="row.status === 'finished'" class="badge-red">Terminé</b>
                                 </div>
                                 </div>

                        </div>
                        <div class="op-infos2" :id="`${row.type}`" v-bind:class="{ bloc_ope_admin: usersinfos.role==='ADMIN'}">
                            <div v-if="usersinfos.role==='ADMIN'" class="menu_op">

                                <div  >
                                    <span class="badge-red" v-if="!row.builderV2">V1</span>
                                    <span class="badge" v-if="row.env==='TEST'">TEST</span>
                                    <span class="badge-green" v-if="row.env==='PROD'">PROD</span>
                                </div>

                                <ul class="operation_menu">
                                    <li v-if="usersinfos.role==='ADMIN'" ><router-link v-tooltip="'Facturation'" aria-hidden="true" class="fa fa-euro-sign" :to='`/operationV2/${row._id}/variablefees`'></router-link></li>
                                    <li ><a v-tooltip="'Statistiques V2'" aria-hidden="true" class="fa fa-line-chart" :href='`https://stats.promo.dev/${row._id}`' target="_blank"></a></li>
                                    <li v-if="row.stats && row.stats.total_participations"><span class="key"><router-link :to="'/data/'+row._id"><i v-tooltip="'Participations'" class="fas fa-users"></i></router-link></span></li>
                                    <li><span class="key" v-clipboard:copy="row._id" v-clipboard:success="onCopy"><i v-tooltip="'Copier la clé'" class="fas fa-key"></i></span></li>
                                    <li><i class="fa fa-clone" v-tooltip="'Dupliquer'" aria-hidden="true" v-on:click="cloneOp(row._id)"></i></li>
                                    <li><router-link :to="'/operation/' + row._id"><i v-tooltip="'Editer'" class="fa fa-pencil-square-o" aria-hidden="true"></i></router-link></li>
                                    <li><a @click="downloadCdctoxml(row._id, row.title)"><i v-tooltip="'Generer le cahier des charges'" class="fa fa-file-excel" aria-hidden="true"></i></a></li>
                                    <li><i class="fa fa-trash-o" v-tooltip="'Supprimer'"  v-on:click="deleteOp(row._id)"></i></li>
                                </ul>

                                <!-- TODO: check that operation has valid form -->
                                <div v-if="(href = saisieHref(row._id))">
                                    <a :href="href" target="_blank" class="text-decoration-none badge-gray">SAISIE</a>
                                </div>
                            </div>
                            <div v-else class="operation_menu_client">
                                <ul>


                                     <li>
                                        <a v-tooltip="'Statistiques V2'" aria-hidden="true" class="fa fa-line-chart" :href="'https://stats.promo.dev/' + row._id" target="_blank"></a>
                                        <br>
                                        <a style="margin-top:15px;display: block;" v-tooltip="'Base de données'" aria-hidden="true" class="fa fa-database" :href="`/operationV2/${row._id}/data`"></a>
                                    </li>
                                                                  <router-link v-if="usersinfos.role==='ADMIN'"

                                          style="padding: 5px 10px;display:inline;position:absolute;top:40px;right:-6px;"

                                          :to="'/data/'+row._id"> <i v-tooltip="'Data'" aria-hidden="true" class="fas fa-eye"></i></router-link>
                                </ul>
                                <div v-if="(href = saisieHref(row._id))">
                                    <a :href="href" target="_blank" class="text-decoration-none badge-gray">SAISIE</a>
                                </div>
                            </div>
                            <div v-if="usersinfos.role==='ADMIN'" class="infosadmin">
                              <div v-if="row.stats">
                                  <p>
                                    PARTICIPATIONS :
                                    <span v-if="row.stats.total_participations">{{
                                        row.stats.total_participations
                                      }}

                                    </span>
                                    <span v-else>0</span>
                                  </p>
                                <p>A TRAITER :
                                  <span v-if="row.stats.total_pending">{{ row.stats.total_pending }}</span>
                                  <span v-else>0</span>
                                </p>
                                <p v-if="row.stats.max_participation > 0">MAX :
                                  <span v-if="row.stats.max_participation">{{ row.stats.max_participation }}</span>
                                  <span v-else>0</span>
                                </p>
                              </div>
                              <div v-if="row.type==='ODR' && row.stats" >
                                 <p >Prochain remboursement :
                                    <span :class="{ 'redbull': ((row.budget-row.stats.total_to_refund) <= 0) }" v-if="row.stats.total_to_refund">{{  row.stats.total_to_refund }}€</span>
                                    <span v-else>0</span>
                                 </p>
                                 <p>Déja remboursé :
                                    <span v-if="row.stats.total_refunded">{{  row.stats.total_refunded }}€</span>
                                    <span v-else>0</span>
                                 </p>
                                 <p>Total ADF :
                                   <span v-if="row.budget">{{ row.budget }}€</span>
                                   <span v-else>0€</span>
                                 </p>
                                 <p>Budget Restant
                                   <span  :class="{ 'redbull': ((row.budget-row.stats.total_refunded) < 0) }" v-if="row.budget">{{ (row.budget-row.stats.total_refunded).toFixed(2) }}€</span>
                                   <span v-else>n/a</span>
                                </p>
                              </div>
                            </div>
                            <div v-if="usersinfos.role!='ADMIN'" class="op-participations">
                                <div>
                                <h3>PARTICIPATIONS

                                    </h3>
                                <p><i class="fas fa-users"></i> &nbsp;<Roller v-if="row.stats" :transition="1" :text="row.stats.total_participations"></Roller> </p>
                                 <hr v-if="row.counter_limit"  />
                                <span v-if="row.counter_limit">{{ row.counter_limit|format_number}}</span>
                                </div>
                            </div>
                            <div  v-if="usersinfos.role!='ADMIN' && row.type==='ODR'" class="op-budget">
                                <h3>REMBOURSEMENT</h3>
                                <p>&nbsp;<Roller  :transition="1" :text="row.total_refund "></Roller> €</p>
                                <hr />
                                <span>{{ row.budget | format_number }} €</span>
                            </div>
                        </div>
                    </div>


        </template>
        <template #noDataFound>
          <div class="col-md-12 pt-2">
            <p class="text-center">Aucun résultats</p>
          </div>
        </template>
      </dataset-item>
      <dataset-info class="ml-4 mb-8" />
      <dataset-pager />

</div>
       </transition>
</div>
    </MyDataset>

    <div v-if="tabIndex === 6 && loaded">
        <div class="new_block" v-for="item in results" :key="item.index"
        >
        <h1><span>Client :</span> {{ item.client }}</h1>
        <div class="new_infos">
            <div>
               <ul>
                   <li>Opérations en cours : <span>{{ item.started}}</span></li>
                   <li>Opérations Terminé : <span>{{ item.finished }}</span></li>
                   <li>Opérations à venir : <span>{{ item.soon }}</span></li>
               </ul>
            </div>
            <div>
               <ul>
                   <li>Prochain remboursement : <span>{{ item.total_refund }}&euro;</span></li>
                   <li>Déja remboursé : <span>{{ item.total_refunded }}&euro;</span></li>
                   <li>Total ADF : <span>{{ item.budget }}&euro;</span></li>
                   <li>Budget restant : <span>{{(item.budget-item.total_refunded).toFixed(2)}}&euro;</span></li>
               </ul>
            </div>
        </div>
        </div>
    </div>




        </div>
    </div>
</template>

<script>

    import Multiselect from "vue-multiselect";
    import { VueTabs, VTab } from 'vue-nav-tabs'
    import 'vue-nav-tabs/themes/vue-tabs.css'
    import Datepicker from 'vuejs-datepicker'
    import { fr } from 'vuejs-datepicker/dist/locale'
    import { SweetModal, SweetModalTab, } from 'sweet-modal-vue'
    import moment from 'moment'
    import auth from '../auth'
    import Vue from 'vue'
    import VueDatepickerLocal from 'vue-datepicker-local'
    import VueFuse from 'vue-fuse'
    import Roller from "vue-roller";
    Vue.use(VueFuse)

    import {
  Dataset,
  DatasetItem,
  DatasetInfo,
  DatasetPager,
  DatasetSearch,
  DatasetShow
} from 'vue-dataset'

import { downloadBlob } from '../utils'

    var datestart =  moment().startOf('day')
    var dateend = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
    var date = new Date(datestart)
    var date2 = new Date(dateend)
    var state = { date: date }

    var enddate = date2
    var enddate = enddate.setDate(enddate.getDate()+30);

        Vue.filter('format_number', function (value) {
                return new Intl.NumberFormat().format(value);
            });




export const MyDataset = {
 extends: Dataset,
  data() {
    return {
      datasetI18n: {
        show: "Limiter à ",
        entries: "opérations par page",
        previous: "Précédent",
        next: "Suivant",
        showing: "Affichage de",
        showingTo: "à",
        showingOf: "sur",
        showingEntries: "opérations",
      }
    }
  }
}


    export default {

        name: 'home',
        components: {
            MyDataset,
            Datepicker,
            SweetModal,
            Multiselect,
            SweetModalTab,
            Roller,
            VueTabs,
            VTab,
            VueDatepickerLocal,
            Dataset,
            DatasetItem,
            DatasetInfo,
            DatasetPager,
            DatasetSearch,
            DatasetShow,
        },
    data: function () {
            return {
                clientList : undefined,
                majstat : false,
                typeList: ["JEU SOA", "JEU WEB", "ODR", "FORMULAIRE", "JEU AVEC REMBOURSEMENT", "PRIME"],
                typeList2: ["GABARIT ODR", "PERSONNALISER"],
                state_op : 'ALL',
                client_op : 'ALL',
                search : '',
                selected: 10,
                logo_url : localStorage.logo_url,
                loaded : false,
                scrollAmount : 0,
                stat_url : undefined,
                results: [],
                statusClass : 'st_orange',
                local: {
                dow: 0,
                yearSuffix: '',
                monthsHead: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Decembre'.split('_'),
                months: 'Jan_Fev_Mar_Avr_Mai_Jun_Jui_Août_Sept_Oct_Nov_Dec'.split('_'),
                weeks: 'Lun_Mar_Mer_Jeu_Ven_Sam_Dim'.split('_')
                },
                operations:[],
                tabIndex : 0,
                totalop : 0,
                statusName : 'En attente',
                form: {
                    title: undefined,
                    date_debut : state.date,
                    date_fin : dateend,
                    date_delete_data: undefined,
                    date_anonymisation_data : undefined,
                    domaine : undefined,
                    builderV2: false,
                },
                usersinfos : auth.getUserInfos(),
                state,
                fr: fr,
            }
        },
        computed: {
            filtered () {

                var filtered = this.operations
                return filtered
            }
        },
        created() {
            this.$on('results', results => {
                this.results = results
                })
        },
        async mounted() {
            if(this.usersinfos.role === 'ADMIN') {

                this.clientList = await this.getUniqClient();

                this.handleTabChange(0)
              //  this.$axios.get('/api/operations/count/').then((response) => {
              //  this.totalop = response.data.status
             //   }).catch((error) => {
             //       console.log(error);
             //   })

            } else {
                this.getAllOperationsForClient()
             //   this.$axios.get('/api/operations/count/'+this.usersinfos.identifiant+'/').then((response) => {
            //    this.totalop = response.data.status
             //   }).catch((error) => {
             //       console.log(error);
             //   })
            }
        },
        methods: {
            async addClient() {
                this.handleTabChange(this.tabIndex)
            },
            async addType() {
                this.handleTabChange(this.tabIndex)
            },
            async getUniqClient() {
            this.$axios
                .get("/api/users/getUniqClient")
                .then((response) => {
                this.clientList = response.data;
                });
            },
            async majStat() {
               this.majstat = true
               this.loaded = false
               var { data } =  await this.$axios.get('/api/operations/majstatistique/');
               this.loaded = true
               this.majstat = false
               location.reload();
            },
            async getParticipations(id) {
                try {
                  var { data }  = await this.$axios.get('/api/operations-custom/counter/'+id)
                } catch(error) {

                }
                return new  Intl.NumberFormat().format(valeur)
            },
            getRefunds(id) {
               return new Intl.NumberFormat().format(134213);
            },
            goToProd(url) {
                window.open('https://'+url.replace(/(^\w+:|^)\/\//, ''));
            },
            dateRange(startDate, endDate) {
            var start      = startDate.split('-');
            var end        = endDate.split('-');
            var startYear  = parseInt(start[0]);
            var endYear    = parseInt(end[0]);
            var dates      = [];

            for(var i = startYear; i <= endYear; i++) {
                var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
                var startMon = i === startYear ? parseInt(start[1])-1 : 0;
                for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
                var month = j+1;
                var displayMonth = month < 10 ? '0'+month : month;
                dates.push([i, displayMonth, '01'].join('-'));
                }
            }
            return dates;
            },
            previewForm(url) {
                this.stat_url = url
                event.preventDefault();
                this.$refs.modal_stat.open();
                return;
            },
           async getAllOperationsForClient() {
               this.loaded = false

                var { data } =  await this.$axios.get('/api/operations/listallop/'+this.usersinfos.identifiant+'/');

                var datas = data.filter((op) => { return !op.archived; });

                this.totalop = datas.length || 0
                var now = new Date().getTime() // Opérations pas encore commencée
                var not_yet = datas.filter(d => { var date_debut = new Date(d.date_debut).getTime();
                    return (now < date_debut);
                });
                not_yet = not_yet.map(v => ({...v, status: 'not_yet' }))

                 var between = datas.filter(d => {  // Opérations en cours
                    var date_debut = new Date(d.date_debut).getTime();
                    var date_fin = new Date(d.date_fin).getTime();
                    return (now > date_debut && now < date_fin);
                });
                between = between.map(v => ({...v, status: 'between' }))



                var finished = datas.filter(d => { // Opérations Terminées
                    var date_fin = new Date(d.date_fin).getTime();
                    return (now > date_fin);
                });


                finished = finished.map(v => ({...v, status: 'finished' }))

                var  list_op = not_yet.concat(between,finished)

                this.infoSupForOp(list_op)

           },
           async infoSupForOp(list_op) {
                for (var key in list_op) {
                    var obj = list_op[key];

                    if(obj.counters && obj.counters.length > 0) {
                        var counter = await this.getCounterValue(obj._id, obj.counters[0].name)

                        if(counter.data.value) {
                            var total_participations = (counter.data.value)
                        } else {
                            var total_participations = 0
                        }
                        list_op[key].counter_limit = obj.counters[0].limit

                    } else {

                        var totalparticipations =  await this.$axios.get('/api/operations-custom/counter/'+obj._id);
                        var total_participations = totalparticipations.data.counter || 0
                    }
                    list_op[key].total_participations = total_participations || 0


                    var totalrefund =  await this.$axios.get('/api/v2/submissions/get_total_refund/'+obj._id);
                    if(totalrefund.data.length > 0) {
                        list_op[key].total_refund = Math.round(totalrefund.data[0].total_refund/100)
                    } else {
                        list_op[key].total_refund = 0
                    }

                    var totalrefunded =  await this.$axios.get('/api/v2/submissions/get_total_refunded/'+obj._id);
                    if(totalrefunded.data.length > 0) {
                        list_op[key].total_refunded = Math.round(totalrefunded.data[0].total_refund/100)
                    } else {
                        list_op[key].total_refunded = 0
                    }

                    if(!list_op[key].budget)  list_op[key].budget=0

                   this.loaded = true
                }
               this.results = list_op
               Vue.set(this, 'operations', list_op)
           },
            async getCounterValue(id, name) {
                return this.$axios.get("/api/v2/counters/"+id+"/"+name);
            },
           async submited() {
                event.preventDefault();

                this.$validator.validateAll().then(async(valid) => {
                    if(valid) {
                        this.form.builderV2 = true
                        var delete_date = new Date(this.form.date_fin);
                        var new_delete_date = delete_date.setMonth(delete_date.getMonth()+6)
                        this.form.date_delete_data  =  new_delete_date;
                        this.form.date_anonymisation_data = new_delete_date;
                        this.form.env = 'TEST'
                        this.form.creatorId = this.usersinfos._id

                        try {
                           let result = await this.$axios.post( '/api/operations/save', {
                                ...this.form
                            });

                            this.$router.push("/operationV2/"+result.data);
                        }
                        catch(error) {
                            console.log(error);
                        }
                    }
                });
            },
            async downloadCdctoxml(id, name) {
                const res = await this.$axios.get(`/api/v2/cdctoxml/${id}`, {
                    responseType: 'blob',
                })
                downloadBlob(`${name}.xlsx`, res.data)
            },
            dateRange(startDate, endDate) {

                var start      = startDate.split('-');
                var end        = endDate.split('-');
                var startYear  = parseInt(start[0]);
                var endYear    = parseInt(end[0]);
                var dates      = [];

                for(var i = startYear; i <= endYear; i++) {
                    var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
                    var startMon = i === startYear ? parseInt(start[1])-1 : 0;
                    for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
                    var month = j+1;
                    var displayMonth = month < 10 ? '0'+month : month;
                    dates.push([i, displayMonth, '01'].join('-'));
                    }
                }
                return dates;
            },
            groupBy(key, array) {
            return array.reduce(
                (objectsByKeyValue, obj) => ({
                ...objectsByKeyValue,
                [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj)
                }),
                {}
            )},
            handleTabChange(tabIndex, newTab, oldTab){
                this.loaded = false


                var status, statusclass;
                if(tabIndex===0) { status='all', statusclass="all" }
                else if(tabIndex===1) {  status='wait', statusclass="not_yet"  }
                else if(tabIndex===2) {  status='open', statusclass="between"  }
                else if(tabIndex===3) {  status='close', statusclass="finished"  }
                else if(tabIndex===4) {  status='saisie', statusclass="saisie"  }
                else if(tabIndex===5) {  status='refunded', statusclass="refunded"  }
                else if(tabIndex===6) {  status='all', statusclass="all"  }
                else if(tabIndex===7) {  status='all', statusclass="all"  }

                this.tabIndex = tabIndex;



                    if(this.usersinfos.role === 'ADMIN') {

                        this.$axios.get('/api/operations/list/'+status).then((response) => {
                        var operations = response.data.map(v => ({...v, status : statusclass }))

                        if(this.state_op === 'TEST' || this.state_op === 'PROD') {
                            operations = operations.filter((op) => { return op.env === this.state_op });
                        }

                        if(this.state_op === 'GABARIT ODR' || this.state_op === 'PERSONNALISER') {
                            operations = operations.filter((op) => { return op.format === this.state_op });
                        }

                       if(this.client_op && this.client_op != 'ALL') {
                           operations = operations.filter((op) => { return op.client === this.client_op });
                       }

                       console.log(this.state_op)





                       // this.totalop = newResult.length || 0

                        if(tabIndex===5) {
                           operations.sort((b,a) => a.stats.total_to_refund - b.stats.total_to_refund);
                         }




                        if(tabIndex===7) {
                           var newArr = operations.filter((op) => { return op.archived; });
                        } else {
                           var newArr = operations.filter((op) => { return !op.archived; });
                        }

                            if(tabIndex===6) {


                            var newResult = []
                            var onlyadf = newArr.filter((op) => {
                                    return op.budget;
                                });
                            var groupBy=this.groupBy('client', onlyadf);
                            for (const entry of Object.entries(groupBy)) {

                                var ttpart = 0;
                                var ttmax = 0;
                                var ttpending = 0;
                                var ttrefund = 0;
                                var ttrefunded = 0;
                                var ttbud = 0
                                var started = 0
                                var finished = 0
                                var soon = 0
                                for (const opes of Object.entries(entry[1])) {

                                    if(opes[1].budget) ttbud += parseInt(opes[1].budget);
                                    if(opes[1].stats) {
                                        if(opes[1].stats.max_participation) ttmax += parseInt(opes[1].stats.max_participation);
                                        if(opes[1].stats.total_participations) ttpart += parseInt(opes[1].stats.total_participations);
                                        if(opes[1].stats.total_pending) ttpending += parseInt(opes[1].stats.total_pending);
                                        if(opes[1].stats.total_to_refund) ttrefund += parseInt(opes[1].stats.total_to_refund);
                                        if(opes[1].stats.total_refunded) ttrefunded += parseInt(opes[1].stats.total_refunded);
                                    }
                                    if(this.checkDate(opes[1].date_debut, opes[1].date_fin)==='started') { started ++; }
                                    if(this.checkDate(opes[1].date_debut, opes[1].date_fin)==='finished') { finished ++;  }
                                    if(this.checkDate(opes[1].date_debut, opes[1].date_fin)==='soon') { soon ++;  }

                                }
                                newResult.push({
                                    'client' : entry[0],
                                    'budget' : ttbud,
                                    'total_participations' : ttpart,
                                    'max_participations' : ttmax,
                                    'total_pending' : ttpending,
                                    'total_refund' : ttrefund,
                                    'total_refunded' : ttrefunded,
                                    'started' : started,
                                    'finished' : finished,
                                    'soon' : soon,
                                })


                            }
                            newResult.sort((b,a) => a.budget - b.budget);
                            this.totalop = newResult.length || 0
                            Vue.set(this, 'operations', newResult);


                            } else {
                            this.totalop = newArr.length || 0
                            Vue.set(this, 'operations', newArr)

                            }

                            this.loaded = true

                        }).catch((error) => {

                            console.log(error);
                        })




                    } else {

                        this.$axios.get('/api/operations/list/'+this.usersinfos.identifiant+'/'+status).then((response) => {
                            Vue.set(this, 'operations', response.data)
                            this.infoSupForOp(response.data)
                        }).catch((error) => {
                            console.log(error);
                        })
                    }
            },
            checkDate(datedeb, dateend) {
                var today = new Date();
                var d1 = new Date(datedeb);
                var d2 = new Date(dateend);
                today.setHours(0,0,0,0);
                var status = undefined

                if(d1 > today) {
                    status = 'soon';
                } else if(d2 < today) {
                    status = 'finished';
                } else {

                    status = 'started';
                }

                return status
            },
            openStats(url) {
                window.open(url)
            },
            copytoclipboard(key) {

                this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Clé API copiée dans le presse papier',
                showConfirmButton: false,
                timer: 1500
                })
            },
            closeModal() {
                event.preventDefault();
                this.$refs.modal.close();
                return;
            },
            openModal() {
                this.$refs.modal.open();
                return;
            },
            onCopy: function(e) {
            this.$swal({
                position: "top-end",
                type: "success",
                title: "Clé API copié avec succès",
                showConfirmButton: false,
                timer: 1500,
            });
            },
            sideScroll(direction){
                var speed = 50;
                var distance = 200;
                var step = 10;
                var scrollAmount = 0
                var element = document.getElementById('timeline_container');

                var slideTimer = setInterval(() =>{
                    if(direction == 'left'){
                        element.scrollLeft -= step;
                    } else {
                        element.scrollLeft += step;
                    }
                    scrollAmount += step;
                    if(scrollAmount >= distance){
                        window.clearInterval(slideTimer);
                    }
                }, speed);
            },
            getTimeRemaining(endtime){
                const total = Date.parse(endtime) - Date.parse(new Date());
                const seconds = Math.floor( (total/1000) % 60 );
                const minutes = Math.floor( (total/1000/60) % 60 );
                const hours = Math.floor( (total/(1000*60*60)) % 24 );
                const days = Math.floor( total/(1000*60*60*24) );

                return {
                    total,
                    days,
                    hours,
                    minutes,
                    seconds
                };
            },
            deleteOp(id) {

                        this.$swal({
                        title: '&Ecirc;tes vous sur ?',
                        text: "Supprimer cette opération ?",
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Oui, je la supprime !'

                        }).then((result) => {
                        if (result.value) {

                            this.$axios.get('/api/operations/delete/'+id).then((response) => {
                                this.handleTabChange(this.tabIndex);
                                this.$swal(
                                    'Supprimée !',
                                    'L\'opération à bien été supprimée.',
                                    'success'
                                    )
                            }).catch((error) => {
                                console.log(error);
                            })
                        }
                        })
                    },
            cloneOp(id) {

                    this.$swal.mixin({
                        input: 'text',
                        confirmButtonText: 'Dupliquer',
                        showCancelButton: true,
                        inputValidator: (value) => {
                            return !value && 'Champ titre obligatoire !'
                        }
                    }).queue([{
                        title: 'Dupliquer cette opération ?',
                        text: 'Merci de donner un titre à la nouvelle opération'
                    }]).then((result) => {
                        if (result.value && result.value[0] != '') {
                            this.$axios.post( '/api/operations/duplicate/' + id, { title : result.value[0] }).then((response) => {
                                this.handleTabChange(this.tabIndex);
                                this.$swal("Dupliqué !" , "L'opération à bien été dupliquée." , "success" )
                            }).catch((error) => {

                            })
                        }
                    })
            },
            saisieHref(id) {
                const base = process.env.VUE_APP_SAISIE_BASE_URL
                if (!base) return null
                return `${base}/${id}`
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<link rel="stylesheet" href="https://unpkg.com/vue-nav-tabs/themes/vue-tabs.css">
<style lang="scss">
.swal2-popup .swal2-styled.swal2-confirm {
    background-color: #63707E;
}



</style>
